/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Toast_Alldeactivated3Inputs */

const en_settings_reportingapikeys_toast_alldeactivated3 = /** @type {(inputs: Settings_Reportingapikeys_Toast_Alldeactivated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All API keys deactivated for the user`)
};

/**
* | output |
* | --- |
* | "All API keys deactivated for the user" |
*
* @param {Settings_Reportingapikeys_Toast_Alldeactivated3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_toast_alldeactivated3 = /** @type {((inputs?: Settings_Reportingapikeys_Toast_Alldeactivated3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Toast_Alldeactivated3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_toast_alldeactivated3(inputs)
});
export { settings_reportingapikeys_toast_alldeactivated3 as "settings_reportingApiKeys_toast_allDeactivated" }